import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets= [
    "selectExclusionSetting",
    "radioRemoveExclusion",
    "radioAllowExclusion",
    "datatable",
    "endpointsForms",
    "exclusionField",
  ]

  static values = {
    url: String
  }

  initialize() {
    this.submitting = false
  }

  connect() {
    $(this.selectExclusionSettingTarget).on("select2:select", function (e) {
      this.onPresetSelect(e.target.value)
    }.bind(this))
    this.setupDataTable()
  }

  confirmLeave(event) {
    if (!this.submitting) {
      event.preventDefault()
      event.returnValue = ""
    }
  }

  async submitForm(event) {
    event.preventDefault()
    this.submitting = true

    const exclusions = this.collectExclusionData()

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ exclusions })
      })

      if (response.ok) {
        window.location.reload()
      } else {
        alert("An error occurred. Please try again.")
        this.submitting = false
      }
    } catch (error) {
      alert("An error occurred. Please try again.")
      this.submitting = false
    }
  }

  collectExclusionData() {
    const exclusions = {}
    const radioButtons = this.element.querySelectorAll('input[type="radio"]:checked')

    radioButtons.forEach((radio) => {
      const name = radio.getAttribute("name")
      const match = name.match(/exclusions\[(\d+)\]\[action\]/)
      if (match) {
        const index = match[1]
        const action = radio.value
        const typeId = this.element.querySelector(`input[name="exclusions[${index}][type_id]"]`).value
        const pathId = this.element.querySelector(`input[name="exclusions[${index}][path_id]"]`).value
        const fileId = this.element.querySelector(`input[name="exclusions[${index}][file_id]"]`).value

        exclusions[index] = {
          action: action,
          type_id: typeId,
          path_id: pathId,
          file_id: fileId
        }
      }
    })

    return exclusions
  }

  setupDataTable(){
    $(this.datatableTarget).DataTable({
      processing: true,
      stateSave: true,
      stateDuration: 300,
      searching: true,
      paging: false,
      columnDefs: [
        { searchable: false, targets: 0 },
        { searchable: false, targets: 0 },
        { searchable: true, targets: 0 },
        { searchable: false, targets: 0 },
        { searchable: false, targets: 0 },
      ]
    })
  }

  onPresetSelect(mode) {
    if (mode == "remove") {
      this.radioRemoveExclusionTargets.forEach((radioButton) => radioButton.checked = true)
    } else if (mode == "allow") {
      this.radioAllowExclusionTargets.forEach((radioButton) => radioButton.checked = true)
    }
  }

  onClickRadioButton(e) {
    $(this.selectExclusionSettingTarget).val("custom")
    $(this.selectExclusionSettingTarget).trigger("change")
  }

  submitEndpointsForm(e) {
    const clickedIndex = $(e.target).data("index")
    const formToSubmit = $(this.endpointsFormsTarget).find(`span[data-index="${clickedIndex}"] > form`)

    // Must use native DOM object + requestSubmit() instead of jquery + submit(), to allow turbo to intercept
    formToSubmit.get(0).requestSubmit()
  }
}
